import { Alert, AlertTitle, Box, CircularProgress, Stack } from "@mui/material";
import { AppContext, AppDispatchContext } from "Contexts/AppContext";
import qs from "qs";
import { useContext, useEffect } from "react";
import { useQuery } from "react-query";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { fetchAPI } from "Utils/Fetch";
import CentralizedLayout from "./CentralizedLayout";
// import { useAPI } from "../Hooks/useAPI";

export function OAuth2HandlerPage() {
    const navigate = useNavigate();
    const appConfig = useContext(AppContext);
    const dispatch = useContext(AppDispatchContext);
    const location = useLocation();
    const { search } = location;
    const parsed = qs.parse(search, { ignoreQueryPrefix: true });
    const {
        error,
        isLoading,
        refetch: doLogin,
    } = useQuery<any, Error>(
        "oauth2",
        async () => {
            const response = await fetchAPI("POST", "/login", parsed);
            if (response.status === 200) {
                const tokens = await response.json();
                localStorage.setItem("accessToken", tokens.accessToken);
                localStorage.setItem("refreshToken", tokens.refreshToken);
                getProfile();
            } else {
                console.error(response);
                throw new Error("Login failed");
            }
        },
        {
            enabled: false,
            refetchOnWindowFocus: false,
        }
    );
    const { data: profile, refetch: getProfile } = useQuery<any, Error>(
        "profile",
        async () => {
            const response = await fetchAPI("GET", "/me");
            return response.json();
        },
        {
            enabled: false,
            refetchOnWindowFocus: false,
        }
    );
    useEffect(() => {
        if (profile) {
            dispatch({
                type: "setProfile",
                payload: {
                    profile,
                },
            });
        } else {
            doLogin();
        }
    }, [profile]);
    useEffect(() => {
        if (appConfig.profile) {
            navigate("/avatars");
        }
    }, [appConfig.profile]);

    // Error and Loading states
    if (error) {
        return (
            <CentralizedLayout>
                <Stack sx={{ width: "100%" }} spacing={2}>
                    <Alert severity="error">
                        <AlertTitle>{error.message}</AlertTitle>
                    </Alert>
                </Stack>
            </CentralizedLayout>
        );
    } else if (isLoading) {
        return (
            <CentralizedLayout>
                <Box sx={{ display: "flex" }}>
                    <CircularProgress size={80} />
                </Box>
            </CentralizedLayout>
        );
    }
    // Show the response if everything is fine
    return (
        <CentralizedLayout>
            <Box sx={{ display: "flex" }}>
                <CircularProgress size={80} />
            </Box>
        </CentralizedLayout>
    );
}
